import axios from 'axios';

export type HubSpotBlueprintProperties = {
	blueprint_name: string;
	standard___custom?: string;
	island_finish?: string;
	kitchen_layout?: string;
	island_quantity?: string;
	island_length?: string;
	island_location?: string;
	countertop?: string;
	countertop_overhang?: string;
	contains_non_coyote_appliances?: string;
	fuel_source?: string;
	cutout_options_2?: string;
	future_project_approval_timeline?: string;
	delayed_delivery?: string;
	install_method?: string;
	payment_type?: string;
	project_folder?: string;
	additional_details?: string;
	css_notes?: string;
	details_to_confirmed?: string;
	contact_name?: string;
	contact_email?: string;
	blueprint_tool_image?: string;
	// Dependent fields
	island_height?: string;
	contains_corner_stand?: string;
	l_shape_is_offset?: string;
	projected_delivery_date?: string;
	blueprint_delayed?: string;
	delayed_reason?: string;
	on_hold_reason?: string;
	on_hold_source?: string;
	projected_off_hold_date?: string;
};

export type HubSpotBlueprintPayload = {
	dealId: string;
	properties: HubSpotBlueprintProperties;
	thumbnail?: string;
};

export type HubSpotBlueprintResult = {
	success: boolean;
	blueprintId: string;
	message: string;
};

export type CreateHubSpotBlueprintParams = {
	payload: HubSpotBlueprintPayload;
	getToken: () => Promise<string>;
	onSuccess?: (result: HubSpotBlueprintResult) => void;
	onError?: (error: string) => void;
};

/**
 * Creates a Blueprint in HubSpot and associates it to a Deal
 */
export const createHubSpotBlueprint = async (params: CreateHubSpotBlueprintParams): Promise<[HubSpotBlueprintResult | null, string | null]> => {
	const { payload, getToken, onSuccess, onError } = params;

	try {
		const token = await getToken();
		const response = await axios.post(`${import.meta.env.VITE_API_URL}/hubspot/blueprint`, payload, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		if (response.status === 200) {
			if (onSuccess) onSuccess(response.data);
			return [response.data, null];
		}

		throw new Error('Error creating HubSpot Blueprint');
	} catch (error) {
		const errorMessage = error instanceof Error ? error.message : 'Error creating HubSpot Blueprint';
		if (onError) onError(errorMessage);
		return [null, errorMessage];
	}
};
